import { ReactComponent as DefaultAvatarIcon } from './default-avatar.svg'

export default DefaultAvatarIcon
